/* eslint-disable no-shadow */
/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
import clsx from 'clsx';
import moment from 'moment';
import React, { useEffect, useState, useContext } from 'react';
import useWidgetAPI from '../../hooks/network/useWidgetAPI';
import WidgetDropdown from './WidgetDropdown';
import { AppContext } from '../../context/AppContext';

function RecentInvoiceDetails({ isSelectedWidget, customerId, projectId, widgetIndex, authToken }) {
  const { getRecentInvoiceData } = useWidgetAPI();
  const [data, setData] = useState();
  const { widgetDropDownOptions: dropDownOptions } = useContext(AppContext);

  useEffect(() => {
    fetchWidgetData(customerId, projectId);
  }, [customerId, projectId]);

  const fetchWidgetData = async (customerId, projectId) => {
    const query = { customerId, projectId };
    const response = await getRecentInvoiceData(query);
    setData(response);
  };

  const renderWidgetBody = () => {
    return (
      <div className='mt-4'>
        <div className='grid grid-cols-2 gap-x-2'>
          <div className='mb-4'>
            <p className='mb-2 text-xs font-medium text-gray-900'>WBS #</p>
            <p className='truncate text-sm font-semibold break:text-lg'>
              <span>{data?.WBS1}</span>
              {data?.WBS2?.trim() && <span>/{data?.WBS2}</span>}
              {data?.WBS3?.trim() && <span>/{data?.WBS3}</span>}
            </p>
          </div>
          <div className='mb-4'>
            <p className='mb-2 text-xs font-medium text-gray-900'>Structural Element #</p>
            <p className='truncate text-sm font-semibold break:text-lg'>
              {data?.ST_ELEMENT_TYPE || '-'}
            </p>
          </div>
          <div className='mb-4'>
            <p className='mb-2 text-xs font-medium text-gray-900'>Product</p>
            <p className='truncate text-sm font-semibold break:text-lg'>{data?.PROD_GRP || '-'}</p>
          </div>
          <div className='mb-4'>
            <p className='mb-2 text-xs font-medium text-gray-900'>Date</p>
            <p className='truncate text-sm font-semibold break:text-lg'>
              {data?.INVOICE_DATE ? moment(data?.INVOICE_DATE).format('DD MMM YYYY') : '-'}
            </p>
          </div>
          <div className='mb-4'>
            <p className='mb-2 text-xs font-medium text-gray-900'>PO #</p>
            <p className='truncate text-sm font-semibold break:text-lg'>
              {data?.['P/O_NO'] || '-'}
            </p>
          </div>
          <div className='mb-4'>
            <p className='mb-2 text-xs font-medium text-gray-900'>DO #</p>
            <p className='truncate text-sm font-semibold text-nblue break:text-lg'>
              {data?.DELIVERY_ORDER_NO || '-'}
            </p>
          </div>
          <div className='mb-4'>
            <p className='mb-2 text-xs font-medium text-gray-900'>Invoice #</p>
            <p className='truncate text-sm font-semibold text-nblue break:text-lg'>
              {data?.INVOICE_NO || '-'}
            </p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      {isSelectedWidget && (
        <div className='rounded-tr-lg rounded-tl-lg border border-solid border-gray-200 bg-[#FFF5EA] py-3 px-3 text-sm font-semibold'>
          {dropDownOptions?.find((f) => f?.customerID === customerId)?.customerName}
        </div>
      )}
      <div
        className={clsx(
          { 'rounded-br-lg rounded-bl-lg': isSelectedWidget },
          'widget-wrapper',
        )}
      >
        <div className='flex items-start justify-between'>
          <div className=''>
            <p className='text-xs font-semibold text-black break:text-sm'>Recent Invoice Detail</p>
          </div>
          <div className='m-0 self-start p-0 text-[8px]'>
            <span className=''>
              {isSelectedWidget && (
                <WidgetDropdown widgetIndex={widgetIndex} scope='RecentInvoiceDetails' isSelected />
              )}
            </span>
          </div>
        </div>
        {authToken ? (
          <form action='https://prodash.natsteel.com.sg:8080/v1/auth/ump' method='post'>
            <input type='hidden' name='token' value={authToken} />
            <input type='hidden' name='path' value={'/invoice-detail'} />
            <button className='w-full'>{renderWidgetBody()}</button>
          </form>
        ) : (
          renderWidgetBody()
        )}
      </div>
    </div>
  );
}

export default RecentInvoiceDetails;
